import {
  ArrowLeftIcon,
  CheckIcon,
  MoveToBottomIcon,
  PencilIcon,
  TrashIcon,
  XIcon,
} from "@primer/octicons-react";
import * as React from "react";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Api from "../api";
import { TextDetail } from "../models";

export const handleDownloadCsv = (uid: string) => {
  const link = `/api/texts/${uid}/download.csv`;
  window.location.href = link;
};

export const handleDownloadApkg = (uid: string) => {
  const link = `/api/texts/${uid}/download.apkg`;
  window.location.href = link;
};

const TextPage: React.FC<{ base: "texts" | "povs" }> = ({ base }) => {
  const [text, setText] = useState<TextDetail | null>(null);
  const [editingId, setEditingId] = useState<number | null>(null);
  const [draftQ, setDraftQ] = useState<string>("");
  const [draftA, setDraftA] = useState<string>("");
  const [saving, setSaving] = useState<boolean>(false);

  const { uid } = useParams<{ uid: string }>();

  async function loadText(uid: string) {
    let res: TextDetail | { errors: string[] };
    try {
      res = await Api.texts.get(uid);
    } catch (err) {
      console.error("Error ocurred while loading text: ", err);
      return;
    }

    if ("errors" in res) {
      // setError(res.errors.join(", "));
      return;
    } else {
      setText(res);
    }
  }

  function startEdit(card: { id: number; question: string; answer: string }) {
    setEditingId(card.id);
    setDraftQ(card.question);
    setDraftA(card.answer);
  }

  function cancelEdit() {
    setEditingId(null);
    setDraftQ("");
    setDraftA("");
  }

  async function saveEdit(id: number) {
    if (!draftQ.trim() || !draftA.trim()) {
      return;
    }
    setSaving(true);
    const res = await Api.cards.update(id, draftQ, draftA);
    setSaving(false);

    if (res && "errors" in res) {
      alert(res.errors.join(", "));
      return;
    }

    setText((text) => {
      if (!text) return null;
      const cards = text.cards.map((c) =>
        c.id === id ? { ...c, question: draftQ, answer: draftA } : c
      );
      return { ...text, cards };
    });
    cancelEdit();
  }

  async function handleDeleteCard(id: number) {
    if (!confirm("Are you sure you want to delete this card?")) {
      return;
    }

    if (!text) {
      return;
    }

    await Api.cards.del(id);
    setText((text) => {
      if (!text) {
        return null;
      }

      const cards = text.cards.filter((card) => card.id !== id);
      return { ...text, cards };
    });
  }

  useEffect(() => {
    if (!uid) {
      return;
    }

    loadText(uid);
  }, [uid]);

  if (!text) {
    return null;
  }

  return (
    <main className="text-page">
      <div className="container">
        <div>
          <div className="back-link">
            <Link to={`/${base}`}>
              <ArrowLeftIcon size={16} />
              Back to all
            </Link>
          </div>
          <div className="topbar">
            <h2>Cards created: {text.cards.length}</h2>
            <div className="download-buttons">
              <button onClick={() => handleDownloadApkg(text.uid)}>
                <MoveToBottomIcon size={16} />
                Download Anki
              </button>
              <button onClick={() => handleDownloadCsv(text.uid)}>
                <MoveToBottomIcon size={16} />
                Download CSV
              </button>
            </div>
          </div>
          <div className="cards">
            {text.cards.map((card) => {
              const isEditing = editingId === card.id;
              return (
                <div className="card-item" key={card.id}>
                  <div className="content">
                    <div className="question">
                      <div className="badge">Q: </div>
                      {isEditing ? (
                        <textarea
                          className="card-edit-input"
                          value={draftQ}
                          onChange={(e) => setDraftQ(e.target.value)}
                          autoFocus
                        />
                      ) : (
                        card.question
                      )}
                    </div>
                    <div className="answer">
                      <div className="badge">A: </div>
                      {isEditing ? (
                        <textarea
                          className="card-edit-input"
                          value={draftA}
                          onChange={(e) => setDraftA(e.target.value)}
                        />
                      ) : (
                        card.answer
                      )}
                    </div>
                  </div>
                  <div className="footer">
                    {isEditing ? (
                      <>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            if (!saving) saveEdit(card.id);
                          }}
                        >
                          <CheckIcon size={16} />
                          Save
                        </a>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            cancelEdit();
                          }}
                        >
                          <XIcon size={16} />
                          Cancel
                        </a>
                      </>
                    ) : (
                      <>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            startEdit(card);
                          }}
                        >
                          <PencilIcon size={16} />
                          Edit
                        </a>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleDeleteCard(card.id);
                          }}
                        >
                          <TrashIcon size={16} />
                          Delete
                        </a>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </main>
  );
};

export default TextPage;
